import { IonContent, IonLabel, IonPage } from "@ionic/react";
import React, { useContext } from "react";
import PageHeader from "./PageHeader";
import { useParams } from "react-router";
import { decodeParam } from "../util/ApiHelper";
import { TranslationMessagesContext } from "../util/Translations";

const DocumentViewer: React.FC = () => {
  const { contentType, fileName, fileURL } = useParams<{
    fileURL: string;
    contentType: string;
    fileName: string;
  }>();
  const decodedFileName = decodeParam(fileName);
  const decodedFileURL = decodeParam(fileURL);
  const decodedContentType = decodeParam(contentType);
  const { translatedMessages } = useContext(TranslationMessagesContext);

  return (
    <IonPage>
      <PageHeader title={`${decodedFileName}`} showBack />

      <IonContent fullscreen>
        <object
          data={decodedFileURL}
          type={decodedContentType}
          width="100%"
          height="100%"
        >
          <IonLabel color={"warning"}>
            {translatedMessages["ErrDocViewing"]?.MessageText ||
              "This document cannot be viewed on this device"}
          </IonLabel>
        </object>
      </IonContent>
    </IonPage>
  );
};

export default DocumentViewer;
